import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { log } from 'console';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { PrintMsgBoxComponent } from '../print-msg-box/print-msg-box.component';

@Component({
  selector: 'app-exam-form',
  templateUrl: './exam-form.component.html',
  styleUrls: ['./exam-form.component.scss']
})
export class ExamFormComponent implements OnInit, AfterViewInit {
  examForm: FormGroup;
  addmissionData: any;
  StudentIdd: string;
  SessionNo: any;
  data: any;
  resData: any;
  InstId: any;
  dialogRef: MatDialogRef<any>;
  collegeList: any;
  filteredCollegeList: any;
  ListOfReg: any;
  filteredListOfReg: any;
  Gen = false;
  isSelectDisabled: boolean = false;
  ShowMsg = false;
  courseStreamList: any;
  Appear = true;
  filteredStreamList: any;
  subDataList: any;
  SubArray: FormArray;
  assignTableData: any[];
  Subjects = [];
  SubCode = [];
  EsID = [];
  HeadSub = [];
  submitpayload: any;
  errMsg: any;
  RgId: any;
  EcId: any;
  FeePaid = false;
  SubTable = false;
  Arr: any;
  StudentPersonalId: string;
  subList: any;
  filteredsubList: any;
  Atddata: any;
  EmId: any;
  Message: string;
  CoCode: any;
  ECID: any;
  SubAtd = false;
  SubMessage = ' ';
  IAatd = false;
  IAMessage = ' ';
  atdstatus = false
  EcIdNew: any;
  RgIdNew: any;
  EfId = 0;
  SaveDisable = false
  resForReport
  collegeCode
  payload: {};
  prefix = '';
  RegnNo = '';
  stuPerRgNo='';
  formattedPrn: any;
  Name: void;
  ReExam: boolean;
  stuName;
  stuCast: any;
  SkipAttendance: boolean;
  groupedSubjects: { [key: string]: string[] } = {};
  groupedSubjects2: { [key: string]: { [key: string]: any[] } } = {};
  validationErrors: { [key: string]: string } = {};
  selectedValues: any[] = [];
  newSelectedValues = [];
  AllSub: any[] = [];
  Sub: any[] = [];
  optData: any;
  optDataForGroup: any;
  Subs = false;
  OptSub = false;
  disabledCheckbox=false;
  savedisabled =false
  SubjectData = [];
  subjectsData = false;
  selectedCheckboxes: any = [];
  GroupData: any[] = [];
  tabs : string;
  disabled = true;
  showtxt = false;
  notOpen = false;
  AdmClosed = false;
  Failed = false;
  noCheckboxSelected = false;
  selectedCodeSet: Set<string> = new Set();
  allowSubjectChange = false;
  attendanceBlocked: boolean = false;
  selectedSubCode: string = '';
  examList: any[] = [];
  filteredExamList: any[] = [];

  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient) { }
  studentId = sessionStorage.getItem('StudentRGID');
  ngOnInit(): void {
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.Failed = sessionStorage.getItem('RepeaterExam') ==='true';
    this.Appear = true;
    this.SaveDisable = true
    this.atdstatus = false
    this.SubAtd = false;
    this.SubMessage = ' ';
    this.IAatd = false;
    this.IAMessage = ' ';
    this.Subjects = []
    this.SubCode = [];
    this.EsID = [];
    this.HeadSub = [];
    this.CoCode = ''
    this.prefix = '';
    this.RegnNo = '';
    this.EfId = 0
    this.FeePaid = false;
    this.Gen = false;
    this.ShowMsg = false;
    this.SubTable = false;
    this.examForm = this.fb.group({
      EmName: new FormControl(''),
      EmId: new FormControl(''),
      SValid: new FormControl(''),
      SApp: new FormControl(''),
      SChng: new FormControl(''),
      RegnNo: new FormControl(''),
      Colg: new FormControl(''),
      Branch: new FormControl(''),
      Name: new FormControl(''),
      Cate: new FormControl(''),
      Center: new FormControl(''),
      Valid: new FormControl(''),
      Valid1: new FormControl(''),
      List: new FormControl(''),
      College: new FormControl(''),
      EsType: new FormControl(''),
      SrNo: new FormControl(''),
      EsId: new FormControl(''),
      Head: new FormControl(''),
      Marks: new FormControl(''),
      NewSub: new FormControl(''),
      Sub: new FormControl(''),
      EsName: new FormControl(''),
      App: new FormControl('Y'),
      SubArray: new FormArray([]),
      stuPerRgNo: new FormControl({ value: '', disabled: true }),
    });
     this.admissionSummary();
     this.getCollege();
    this.getScretData();
    this.prepopulation()
    this.getAppliTracker();
    this.searchValid();
  }

  ngAfterViewInit() {
    
  }

  getSubArrayControls() {
    return (this.examForm.get('SubArray') as FormArray).controls;
  }

   admissionSummary() {
        console.log(this.umsService);
console.log(this.umsService.studentCompSummary);
    console.log("................shraddha")
  const payload = {
    StuId: Number(sessionStorage.getItem('StudentPersonalId'))
  };
  this.umsService.studentCompSummary(payload).subscribe((res) => {
    // console.log(req)
    if (res.status && res.data?.length > 0) {
      const examFormsRaw = res.data.filter(x => x.type === 'examForm');
      const examForms = examFormsRaw.filter(
        (exam, index, self) =>
          index === self.findIndex(e => e.SnNo === exam.SnNo)
      );

      if (examForms.length > 0) {
          this.examList = examForms.map(e => ({
          ...e,
          EmId: Number(e.EmId),
          SnNo: Number(e.SnNo)
        }));

        this.filteredExamList = [...this.examList];

        const currentExam = this.examList.reduce((prev, curr) =>
          prev.SnNo > curr.SnNo ? prev : curr
        );

        this.examForm.patchValue({
          EmName: currentExam.EmId
        });

        this.SessionNo = currentExam.SnNo;

        this.loadExam(currentExam);
      }
    }
  });
}

  onExamChange(selectedEmId: number) {
  const selectedExam = this.examList.find(e => e.EmId === selectedEmId);
  if (selectedExam) {
    this.SessionNo = selectedExam.SnNo;
    let payload = {};
    payload['RgNo'] = sessionStorage.getItem('StudentRGID');
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['Valid'] = '';
    payload['Chng'] = '';
    payload['App'] = '';
    payload['EfId'] = 0
    this.umsService.fetchInputExams(payload).subscribe((res) => {
      console.log(res,">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
      if (res.status) {
        if (res.data.filter(e => e.EmId === selectedEmId).find(item => item['Valid'] == 'X')) {
          this.spinner.hide()
          this.SaveDisable = false
        }
        else if (res.data.find(e => e.EmId === selectedEmId)['Valid'] == 'Y') {
          this.spinner.hide()
          this.SaveDisable = true
        }
        else {
          this.spinner.hide()
        }
      } else {
        this.spinner.hide()
        this.SaveDisable = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisable = false
    });
    this.loadExam(selectedExam);
  }
}

  loadExam(exam) {
  this.EcIdNew = exam.EcId;
  this.RgIdNew = exam.RgId;
  this.prepopulationOfAddmission(exam.SnNo,exam.EmId);
}

  addNewRow() {
    const creds = this.examForm.controls.SubArray as FormArray;
    creds.push(
      this.fb.group({
        EsType: new FormControl(''),
        SrNo: new FormControl(''),
        EsParent: new FormControl(''),
        EsId: new FormControl(''),
        Head: new FormControl(''),
        Marks: new FormControl(''),
        NewSub: new FormControl(''),
        Sub: new FormControl(''),
        EsName: new FormControl(''),
        App: new FormControl('Y'),
      })
    );
  }

  getCollege() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      if(res.status){
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
        this.spinner.hide();
      }
      else{
        this.collegeList = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  prepopulation() {
    this.spinner.show()
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.stuName = res.data[0]['StudentFullName']
        this.examForm.controls['stuPerRgNo'].setValue(res.data[0]['stuPerRgNo'] || '');
        this.examForm.controls['Name'].setValue(this.stuName);
        this.spinner.show()
        let payload1 = {};
        payload1['StuId'] = this.StudentPersonalId;
        this.umsService.fetchReservationDetails(payload1).subscribe((res) => {
          if(res.status){
            this.spinner.hide()
            this.fetchSocialReservation(res.data[0]['StuConstiSubCate'])
          }
          else{
            this.spinner.hide()
          }
        }, (ERROR: HttpErrorResponse) => {
          this.collegeList = [];
          this.spinner.hide();
        })
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  checkSession(SnNo){
    this.spinner.show()
    const payload = {};
    payload['SnNo'] = SnNo;
    this.umsService.getSession(payload).subscribe(res => {
      if(res.status){
        if(res.data[0]['SnName'].includes('Re')){
          this.ReExam = true;
        }
        else{
          this.ReExam = false;
        }
        this.spinner.hide()
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getScretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if(arrActiveFlow[0]['SkipAttendance'] == 1){
          this.SkipAttendance = true;
        }
        else if(arrActiveFlow[0]['SkipAttendance'] == 0){
          this.SkipAttendance = false;
        }
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo'];
        this.InstId = res.projectPharam['ClubPartTrans'];
        this.checkSession(res.projectPharam['SnNo']);
        this.SubjectSelectionData(res.projectPharam['SnNo'])
        // this.prepopulationOfAddmission(SnNo, null);
        this.prepopulationOfAddmission(res.projectPharam['SnNo'], null);
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  fetchSocialReservation(caste) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        res.data.filter(item =>{
          if( item.CdCode == caste){
            this.stuCast = item.CdDesc
          }
        })
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  SubjectSelectionData(SnNo) {
    this.spinner.show()
    this.CoCode = '';
    this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
    const payload = {};
    payload['StuId'] = this.StudentIdd,
      this.umsService.StudentSubjectSelectionById(payload).subscribe(res => {
        if (res.status) {
          this.spinner.hide()
          this.addmissionData = res.data[res.data.length - 1];
          if (this.addmissionData?.StuSubjectRgCopy) {
            const codes = this.addmissionData.StuSubjectRgCopy
              .split(',')
              .map(x => x.split('-')[0].trim());
            this.selectedCodeSet = new Set(codes);
          }

          this.examForm.controls['Colg'].setValue(this.addmissionData['SubCgId']);
          this.examForm.controls['College'].setValue(this.addmissionData['SubCgId']);
          this.CoCode = res.data[0]['SubCoId'];
          this.getExamStreamData(res.data[0]['SubCoId'], res.data[0]['SubBrId'])
          this.searchExamForm(res.data[0]['SubCgId'], res.data[0]['SubCoId'], SnNo, res.data[0]['SubBrId'], res.data[0]['SubEmId'])
        }
        else {
          this.spinner.hide()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      })
  }

 prepopulationOfAddmission(SnNo, EmId?:any) {
    this.spinner.show()
    this.CoCode = '';
    this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
    let payload = {};
    payload['StuId'] = this.StudentIdd;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        let emId = res.data[0]['StuEmId']
        if( EmId != null){
          emId = EmId
        }
        this.spinner.hide()
        this.addmissionData = res.data[0];
      

        this.examForm.controls['Colg'].setValue(this.addmissionData['StuCgId']);
        this.examForm.controls['College'].setValue(this.addmissionData['StuCgId']);
        this.examForm.controls['Cate'].setValue(this.addmissionData['StuSpecialCate']);
        this.searchExamForm(res.data[0]['StuCgId'], res.data[0]['StuCoId'], SnNo,res.data[0]['StuBrId'], emId)
        this.CoCode = res.data[0]['StuCoId'];
       this.getExamStreamData(res.data[0]['StuCoId'],res.data[0]['StuBrId'])
  //  this.searchExamForm(res.data[0]['StuCgId'], res.data[0]['StuCoId'], SnNo,res.data[0]['StuBrId'],res.data[0]['StuEmId'])

   }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  loadExamSubjects() {

  if (!this.EmId) return;

  this.spinner.show();

  const payload = {
    EsEmId: this.EmId,
    EsStrId: this.addmissionData?.SubBrId || 0
  };

  this.umsService.getExamSubMapFetch(payload).subscribe(res => {
    this.spinner.hide();

    if(res.status && res.data){

      let d = res.data;

      if(Array.isArray(d)) this.SubjectData = d;
      else if(d?.children) this.SubjectData = d.children;
      else if(d?.data) this.SubjectData = d.data;
      else this.SubjectData = [];
      if(this.SubjectData.length > 0){
        this.loadPreviouslySelectedSubjects();
        this.processAndDisplaySubjects();  
         this.subjectsData = true;
          this.getSubjectOptions(); 
      }
    }
  });
  }

  loadPreviouslySelected() {
  if (!this.addmissionData?.StuSubjectRgCopy) return;
  const arr = this.addmissionData.StuSubjectRgCopy.split(',');
  this.newSelectedValues = arr.map(x => {
    const [code,id] = x.split('-');
    return { Code: code.trim(), Id:id };
  });
  }


  getExamStreamData(id,branch) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.examForm.controls['Branch'].setValue(parseInt(branch));
      }
      else{
        this.spinner.hide()
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  searchExamForm(CgCode, CoCode, SnNo,branch,EmId) {
    this.spinner.show()
    this.EmId = 0;
    const payload = {};
    payload['StuId'] = this.StudentIdd;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.RgId = res.data[0]['RgId'];
        this.GetEcId(res.data[0]['RgId'],CgCode, CoCode, SnNo,branch,EmId)
      }
      else{
        this.spinner.hide()
        this.getstuSubject();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  searchExams(RgId,CgCode, CoCode, SnNo,branch,EmId){
    this.spinner.show()
    let payload = {};
    this.EfId = 0;
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
     this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      this.resForReport = res.data[0];
      this.EfId = res.data[0]['EfId'];
       if (res.status) {
        if (res.data[0]['Cate'] =='X') {
            this.Failed = true;
            this.allowSubjectChange = false
          }
          else {
            this.Failed = false;
          }
          if(res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null){
            this.spinner.hide()
            this.EmId = res.dats[0]['EmId'];
            this.loadExamSubjects()
            //this.ExmFrmEditListCo(CgCode, CoCode, SnNo, this.EmId ,branch,res.data[0]['EcId'],RgId)
            this.EcIdNew = res.data[0]['EcId'];
            this.RgIdNew = RgId;
            this.ExmFrmEditListCo(CgCode, CoCode, sessionStorage.getItem("session"), this.EmId ,branch,this.EcIdNew,this.RgIdNew)
            
          }
          else{
            this.spinner.hide()
            this.EmId = res.data[0]['EmId']
            this.loadExamSubjects();
            //this.ExmFrmEditListCo(CgCode, CoCode, SnNo, this.EmId ,branch,res.data[0]['EcId'],RgId)
            this.EcIdNew = res.data[0]['EcId'];
            this.RgIdNew = RgId;
            this.ExmFrmEditListCo(CgCode, CoCode, sessionStorage.getItem("session"), this.EmId ,branch,this.EcIdNew,this.RgIdNew)
          }
      }
        else{
          this.spinner.hide()
        }
     },(ERROR : HttpErrorResponse) => {
      this.spinner.hide()
     });
   }

   GetEcId(RgId,CgCode, CoCode, SnNo,branch,EmId){
    this.spinner.show()
    let payload = {};
    this.EfId = 0;
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
     this.umsService.GetEcId(payload).subscribe((res) => {
      this.resForReport = res.data[0];
      this.EfId = res.data[0]['EfId'];
       if (res.status) {
          if(res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null){
            this.spinner.hide()
            this.EmId = EmId
           this.loadExamSubjects();
            this.ExmFrmEditListCo(CgCode, CoCode, sessionStorage.getItem("session"), EmId ,branch,res.data[0]['EcId'],RgId)
          }
          else{
            this.spinner.hide()
            this.EmId = res.data[0]['EmId']
             this.loadExamSubjects();
            this.ExmFrmEditListCo(CgCode, CoCode, sessionStorage.getItem("session"), EmId ,branch,res.data[0]['EcId'],RgId)
          }
       } 
       else{
        this.spinner.hide()
       }
     },(ERROR : HttpErrorResponse) => {
      this.spinner.hide()
     });
  }

  NewValidate(data) {
    this.spinner.show()
    let payload = {};
    payload['EcId'] = data.EcId;
    payload['ForRgId'] = this.RgId;
    payload['ForSrNo'] = 0;
    payload['Inst'] = data.Inst;
    payload['LoginId'] = data.LoginId;
    this.umsService.NewvalidateGenExams(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      }
      else{
        this.spinner.hide()
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  ExmFrmEditListCo(CgCode, CoCode, SnNo, EmId, branch, ecid, rgid) {
    this.spinner.show()
    this.payload = []
    this.spinner.show();
    this.RgIdNew = this.RgIdNew;
    this.EcIdNew = this.EcIdNew
    let payload = {};
    payload['SnNo'] = SnNo;
    payload['InCode'] = 19;
    payload['EmId'] = EmId;
    this.umsService.ExmFrmEditListCo(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide();
        this.data = res.data[0];
        this.examForm.controls['List'].setValue(this.data['EcId']);
        this.ListOfReg = res.data;
        this.filteredListOfReg = this.ListOfReg.slice();
        this.Gen = true;
        this.ShowMsg = false;
        const promises: Promise<void>[] = [];
        const promise1 = new Promise<void>((resolve, reject) => {
          let payload = {};
          payload['LoginId'] = this.data['EcOpId'];
          payload['EmId'] = this.data['EmId'];
          payload['CgCode'] = CgCode;
          payload['Branch'] = '';
          payload['Cate'] = 'A';
          payload['RgNo'] = parseInt(this.studentId);
          payload['ForSnNo'] = "";
          payload['SoftCopy'] = "";
          payload['EcId'] = this.data['EcId'];
          payload['Inst'] = this.InstId;
          payload['StuId'] = this.addmissionData['StuId'];
          this.payload = payload
          if (!this.EfId || this.EfId === 0) {
          this.umsService.GenExmForm(payload).subscribe((res) => {
            if (res.status) {
              if (res.message == "No new form generated") {
                this.spinner.hide()
              }
              else if (res.message != "No new form generated") {
                this.spinner.hide()
              }

            }
            resolve();
          })
        }
        });
        const promise2 = new Promise<void>((resolve, reject) => {
          let payload = {};
          payload['StuRgNo'] = this.studentId;
          this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
            if (res.status) {
              this.spinner.hide()
              this.examForm.controls['Name'].setValue(res.data[0]['StuFullNameEng']);
              this.examForm.controls['RegnNo'].setValue(res.data[0]['StuRgNo']);
              this.getCourse()
            }
            else {
              this.spinner.hide()
            }
            resolve();
          })
        });

        promises.push(promise1);
        promises.push(promise2);

        Promise.all(promises).then(() => {
          this.spinner.hide()
          this.ExmFormSub(ecid, rgid);
          this.EcIdNew = ecid
          this.RgIdNew = rgid

        });
      }
      else {
        // this.spinner.hide()
        const payload = {};
        payload['RgNo'] = sessionStorage.getItem('StudentRGID');
        payload['SnNo'] = parseInt(this.SessionNo)
        this.umsService.GetStuSubject(payload).subscribe((res) => {
          // this.spinner.hide();
          if (res.status) {
            this.spinner.hide();
            this.personalDetail()
            this.assignTableData = res.data;
           // this.SubTable = true;
            this.SubArray = this.examForm.get('SubArray') as FormArray;
            this.SubArray.clear();
            this.assignTableData.forEach((element, i) => {
              const showDropdown = !element.Head;
              const showYN = element.EsOpCode
              this.isSelectDisabled = !showYN;
              const creds = this.examForm.controls.SubArray as FormArray;
              creds.push(
                this.fb.group({
                  EsType: new FormControl(element.EsType),
                  SrNo: new FormControl(1),
                  EsId: new FormControl(element.SEsId),
                  EsParent: new FormControl(element.EsParent),
                  Head: new FormControl(element.Head),
                  Marks: new FormControl(element.Marks),
                  NewSub: new FormControl(element.NewSub),
                  Sub: new FormControl(element.Sub),
                  EsName: new FormControl(element.EsName),
                  Pass: new FormControl(''),
                  App: new FormControl(element.App),
                  showDropdown: new FormControl(showDropdown),
                  showYN: new FormControl(showYN)
                })

              );
              });
              let x = (this.examForm.get('SubArray') as FormArray).controls;
              x.forEach(element => {
                element['controls']['App'].setValue('Y');
              });

           // this.fetchStudentAttd();
            this.Gen = false;
            this.ShowMsg = true;
            this.Message = 'This Exam Form Is Already Generated'
          }
          else {
            this.spinner.hide();
            this.Gen = false;
            this.ShowMsg = false;
            this.assignTableData = []
            //this.SubTable = false;
          }

        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
        })
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  isVisible(subData: FormArray): boolean {
    const esTypeToShow = 'S';
    return subData.get('EsType').value === esTypeToShow;
  }

  getFeeTempData(CgCode, CoCode, SnNo, payload1) {
    this.spinner.show();
    this.collegeCode = CgCode
    this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = SnNo,
    payload['CoCode'] = CoCode
    payload['CgCode'] = CgCode
    payload['StuId'] = this.StudentIdd;
    payload['FeeType'] = 'EF';
    this.umsService.fetchFeeTemp(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd, payload1)
      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          this.NewValidate(payload1);
          this.FeePaid = false;
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  SearchFeeDetails(TempCode, StdId, payload1) {
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let data = 0
        res.data.forEach(element => {
          data += element.FeeAmt
        });

        if (data == res.data[0]['TotalPaidAmount']) {
         
          this.FeePaid = true;
        }
        else if (data != res.data[0]['TotalPaidAmount']) {
          this.NewValidate(payload1);
          this.FeePaid = false;
        }
      } else {
        this.NewValidate(payload1);
        this.FeePaid = false;
      }
    });
  }

  
  validateGeneratedExams(data) {
    this.spinner.show()
    let payload = {};
    payload['EcId'] = data.EcId;
    payload['ForRgId'] = this.RgId;
    payload['ForSrNo'] = 0;
    payload['Inst'] = data.Inst;
    payload['LoginId'] = data.LoginId;
    this.umsService.PutvalidateGeneratedExams(payload).subscribe((res) => {
      if (res.status) {
        
        this.saveApplicationDetails()
      }
      else{
        this.spinner.hide();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      });
      this.getValidationErrorsKeys()
  }

 saveApplicationDetails() {
  // const currentDate = new Date();
  // const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['SessionId'] =  this.SessionNo;
    payload['CgCode'] = this.collegeCode;
    payload['CoCode'] = this.CoCode;
    payload['ApplicationName'] ='Exam Form'
    // payload['ApplicationSubDate'] =formattedDate;
      this.umsService.saveApplicationDetails(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide()
        } else {
          this.spinner.hide()
        }
      })
  }

  personalDetail() {
    this.spinner.show()
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.examForm.controls['Name'].setValue(res.data[0]['StuFullNameEng']);
        this.examForm.controls['RegnNo'].setValue(res.data[0]['StuRgNo']);
        this.getCourse();
      }
      else{
        this.spinner.hide()
      }
    },(ERROR : HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  ExmFormSub(EcId, RgId) { 
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.spinner.hide()
        this.Gen = true;
        this.assignTableData = res.data;
        //this.SubTable = true;
        // this.SubArray = this.examForm.get('SubArray') as FormArray;
        const creds = this.examForm.get('SubArray') as FormArray;
        // ✅ Clear once (outside loop)
  creds.clear();
        // this.SubArray = this.examForm.get('SubArray') as FormArray;
        //   SubArray.clear();
        this.assignTableData.forEach((element, i) => {
          const showDropdown = !element.Head;
          const showYN = element.EsOpCode
          const creds = this.examForm.controls.SubArray as FormArray;
          creds.push(
            this.fb.group({
              EsType: new FormControl(element.EsType),
              SrNo: new FormControl(1),
              //EsId: new FormControl(element.SEsId),
              EsId: new FormControl(element.SEsId),  
              OldEsId: new FormControl(element.SEsId), 
              EsParent: new FormControl(element.EsParent),
              Head: new FormControl(element.Head),
              Marks: new FormControl(element.Marks),
              NewSub: new FormControl(element.NewSub),
              Sub: new FormControl(element.Sub),
              EsName: new FormControl(element.EsName),
              Pass: new FormControl(''),
              // App: new FormControl(element.App),
              App: new FormControl(element.App?.trim() ? element.App : 'Y'),
              showDropdown: new FormControl(showDropdown),
              showYN: new FormControl(showYN)
            })
          );
          // let x = (this.examForm.get('SubArray') as FormArray).controls;
          // x.forEach(element => {
          //   element['controls']['App'].setValue('Y');
          // });

        });
       // this.fetchStudentAttd();
      }
      else {
        this.spinner.hide()
        this.Gen = false;
        this.assignTableData = []
        //this.SubTable = false;
        this.SubArray = this.examForm.get('SubArray') as FormArray;
        this.SubArray.push(
          this.fb.group({
            EsType: new FormControl(''),
            SrNo: new FormControl(''),
            EsId: new FormControl(''),
            Head: new FormControl(''),
            Marks: new FormControl(''),
            NewSub: new FormControl(''),
            Sub: new FormControl(''),
            EsName: new FormControl(''),
            Pass: new FormControl(''),
            App: new FormControl('Y'),
            EsParent: new FormControl(''),
          })
        );
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.subDataList = []
    })
  }

 getstuSubject(){
  this.spinner.show()
    const payload = {};
    payload['RgNo'] = this.studentId;
    this.umsService.getStuSubject(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.subList = res.data;
         this.filteredsubList = this.subList.slice();
      } else {
        this.spinner.hide()
        this.subList = []
        }
    },(ERROR : HttpErrorResponse) => {
      this.spinner.hide()
    });

}

isAttendanceDeficient(subData): boolean {
  // Check both conditions, replace with actual condition for fees
  let value = false
  let SubjectCode = subData.get('Sub').value
  this.SubCode.forEach(element => {
    if (element === SubjectCode) {
      value = true;
    }
  });
  return value
 
}


  Generate() {
  if (this.getValidationErrorsKeys().length > 0) {
    const errorMessages = Object.values(this.validationErrors).join('<br>');
    const data = {
      message2: errorMessages,
      title: 'Validation Errors',
      icon: 'fas fa-exclamation-circle',
    };
    this.dialogRef = this.modalPopupService
      .openPopup<AlertboxComponent>(AlertboxComponent, data);
    return; 
  }
 if (!this.assignTableData || this.assignTableData.length === 0) {
  this.submitExamForm();
  return;
}
  // if (this.getValidationErrorsKeys().length > 0) {
  //   const errorMessages = Object.values(this.validationErrors).join('<br>');
  //   const data = {
  //     message2: errorMessages,
  //     title: 'Validation Errors',
  //     icon: 'fas fa-exclamation-circle',
  //   };
  //   this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  //   return;
  // }
  
    let array = this.examForm.controls.SubArray as FormArray;
    let payload = array.value;
    let isAnyControlTouched = false;
    payload.forEach((element, index) => {
      if (element.EsType == 'S' && element.App == ' ') {
        // Set error for mandatory validation
        array.controls[index].get('App').setErrors({ mandatory: true });
        array.controls[index].get('App').markAsTouched();
        isAnyControlTouched = true;
      } else if(element.EsType == 'S' && element.App != ' '){
        // Clear the error for successful validation
        array.controls[index].get('App').setErrors(null);
        
      }
    
      

    });
    if (isAnyControlTouched == false) {
      // Call the API only if no control is marked as touched
      this.submitExamForm()
    }
   }


saveSubjectSelections() {
 const grouped1 = Object.values(this.groupedSubjects || {}).reduce(
  (acc: any[], arr: any) => acc.concat(arr),
  []
);

const grouped2 = Object.values(this.groupedSubjects2 || {}).reduce(
  (acc: any[], arr: any) => acc.concat(arr),
  []
);
const allSubjects = [...grouped1, ...grouped2];
this.selectedCheckboxes = allSubjects.filter((x: any) => x.checked);

if (!this.selectedCheckboxes || this.selectedCheckboxes.length === 0) {
  return;
}


  const finalSubjects = this.selectedCheckboxes.filter((x: any) => x.EsType !== 'G');
  const StuSubjectRg      = finalSubjects.map((x: any) => x.EsCode).join(',');
  const StuSubjectRgCopy  = finalSubjects.map((x: any) => `${x.EsCode}-${x.EsParent}`).join(',');
  const StuSubjectName    = finalSubjects.map((x: any) => x.EsName).join(',');
  const payload = {
    SubSecId: 0,
    SubSession: this.SessionNo,
    SubFacId: this.addmissionData['SubFacId'],
    SubCoId: this.addmissionData['SubCoId'],
    SubBrId: this.addmissionData['SubBrId'],
    SubEmId: this.EmId,
    SubCgId: this.addmissionData['SubCgId'],
    StuSubjectRg: StuSubjectRg,
    StuId: parseInt(this.StudentPersonalId),
    StuSubjectRgCopy: StuSubjectRgCopy,
    StuSubjectName: StuSubjectName,
    AMD: 'A'     
  };
  this.umsService.addSubjectSelectionDetails(payload)
    .subscribe(
      (res) => {
        if (res.status) {
        } else {
        }
      },
      (err) => {
      }
    );
}


async submitExamForm() {
    const { noAttendance, lessAttendance } = await this.fetchStudentAttd();
    if (noAttendance.length > 0) {
    this.modalPopupService.openPopup<AlertboxComponent>(
      AlertboxComponent,
      {
        title: 'Information',
        icon: 'fas fa-close',
        message: `Attendance not available for ${noAttendance.join(', ')}`
      }
    );
    return;
  }
if (lessAttendance.length > 0 && this.ReExam === false) {
  const attendancePopup = this.modalPopupService.openPopup<AlertboxComponent>(
    AlertboxComponent,
    {
      title: 'Information',
      icon: 'fas fa-close',
      message: `Attendance is less for ${lessAttendance.join(', ')}`
    }
  );
  attendancePopup.afterClosed().subscribe(() => {

    const confirmPopup = this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        {
          title: 'Alert',
          icon: 'fa fa-question',
          message: `You will not be able to appear for the following subjects: ${lessAttendance.join(', ')}. Are you sure you want to proceed?`
        }
      );
      confirmPopup.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.saveExamForm();
        }
      });
    });
    return; 
  }
  this.saveExamForm();
}


 

fetchStudentAttd(): Promise<{noAttendance: string[]; lessAttendance: string[];}> {
  return new Promise((resolve) => {
    this.spinner.show();
    this.saveSubjectSelections();
    const payload = {
      StuID: this.StudentPersonalId,
      EmId: this.EmId
    };
    this.umsService.StuAttendance(payload).subscribe(
      (res) => {
        this.spinner.hide();
        const noAttendance: string[] = [];
        const lessAttendance: string[] = [];
        if (!res.status || !res.data || !res.data[0]?.length) {
          resolve({ noAttendance: [], lessAttendance: [] });
          return;
        }
        const attendanceList = res.data[0];
        const selectedSubjects = this.selectedCheckboxes.filter(s => s.EsType === 'S');
        const subjectCodeToIdMap = new Map<string, number>();
        this.SubjectData.forEach(subject => {
          if (subject.EsType === 'S') {
            subjectCodeToIdMap.set(subject.EsCode, subject.EsId);
          } else if (subject.EsType === 'G' && subject.children) {
            subject.children.forEach(child => {
              if (child.EsType === 'S') {
                subjectCodeToIdMap.set(child.EsCode, child.EsId);
              }
            });
          }
        });

  selectedSubjects.forEach(sub => {
  const subject = attendanceList.find(x => x.SubCode === sub.EsCode);

  if (!subject) {
    noAttendance.push(sub.EsName);
    return;
  }
if (
  (subject.AttendStatus === 'N' || subject.AttendStatus === null)
  && this.ReExam === false
) {
  lessAttendance.push(sub.EsCode);
  
  const subArray = this.examForm.get('SubArray') as FormArray;
  const subjectEsId = sub.EsId; 
  const subjectInArray = subArray.controls.find(ctrl => 
    ctrl.get('EsId')?.value === subjectEsId
  );
  
  if (subjectInArray) {
    subjectInArray.get('App')?.setValue('N');
    subArray.controls.forEach(ctrl => {
      if (ctrl.get('EsParent')?.value === subjectEsId) {
      ctrl.get('App')?.setValue('N');
      }
    });
  } else {
      const newSubject = this.fb.group({
      EsType: new FormControl('S'),
      SrNo: new FormControl(1),
      EsId: new FormControl(subjectEsId),
      OldEsId: new FormControl(subjectEsId),
      EsParent: new FormControl(0),
      Head: new FormControl(''),
      Marks: new FormControl(''),
      NewSub: new FormControl(''),
      Sub: new FormControl(sub.EsCode),
      EsName: new FormControl(sub.EsName),
      Pass: new FormControl(''),
      App: new FormControl('N'), 
      showDropdown: new FormControl(true),
      showYN: new FormControl('Y')
    });
    subArray.push(newSubject);
  }
  }
  });
    resolve({ noAttendance, lessAttendance });
    },
    () => {
      this.spinner.hide();
      resolve({ noAttendance: [], lessAttendance: [] });
      }
    );
  });
}



  NewSemAtd(){
    this.spinner.show()
    const payload = {};
    this.Subjects = [];
    this.SubCode = [];
    this.EsID = [];
    this.SubAtd = false;
    this.atdstatus = false;
    this.SubMessage = ' ';
    payload['StuID'] = this.StudentPersonalId;
    payload['EmId'] = this.EmId;
    payload['SessionID'] = this.SessionNo;
    payload['CoCode'] = this.CoCode
    this.umsService.StuAttendanceNewSem(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        if(this.ReExam == false){
          this.SaveDisable = false
          let attendanceData = res.data[0]
          res.data[0].forEach(element => {
            if(element.AttendStatus == 'N' || element.AttendStatus == null){
              const isDuplicate = this.Subjects.some((item: any) => item === element.EsName);
              if (!isDuplicate) {
                this.Subjects.push(element.EsName)
              }
              this.SubCode.push(element.EsCode)
              this.EsID.push(element.EsId);
             
            }
          });
          this.SubArray = this.examForm.get('SubArray') as FormArray;
          this.SubCode.forEach(element => {
            this.SubArray.value.forEach((element2, index) => {
              if(element2['EsType'] == 'S'){
                if(element2['Sub'] == element){
                  this.SubArray.at(index).get('App').setValue('N');
                  this.cdr.detectChanges();
                }
                
              }
              if(element2['EsType'] == 'P'){
                this.EsID.forEach(element3 => {
                  if(element3 == element2['EsParent']){
                    this.SubArray.at(index).get('App').setValue('N');
                  }
                });
                
             
              }
            });
           
          });
         
        
          if (res.data[0].find(item => item.AttendStatus === 'N')) {
            this.SaveDisable = false
            this.atdstatus = true
            let data = {}
            data['message'] = "Attendance Is Less For " + this.Subjects + " Subjects"
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
            this.dialogRef.afterClosed().subscribe((result) => {
              this.fetchStudentIAAtd();
            });
            this.SubAtd = true;
            this.SubMessage = "Attendance Is Less For " + this.Subjects + " Subjects"
          }
          else{
            this.SaveDisable = false
            this.SubAtd = false;
            this.SubMessage = ' ';
            this.fetchStudentIAAtd();
  
          }
        }
        else{
          this.SubAtd = false;
          this.SubMessage = ' ';
        }
      } else {
        this.spinner.hide()
        this.SubAtd = false;
        this.SubMessage = ' ';
        if(this.SkipAttendance == false){
          let data = {}
          data['message'] = "Attendance Not Available For Subjects"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.SaveDisable = true;
        }

        
      }
    }, (ERROR: HttpErrorResponse) => {
        if(this.SkipAttendance == false){
          this.spinner.hide()
          if(this.ReExam == false){
            this.SubAtd = false;
            this.SubMessage = ' ';
            let data = {}
            data['message'] = "Attendance Not Available For Subjects"
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
            this.SaveDisable = true;
          }
        }
        else if(this.SkipAttendance == true){
          this.spinner.hide()
        }
        
    });
  }

  setDescendantsToN(esId: number, subArray: FormArray) {
    subArray.value.forEach((element, index) => {
      if (element['EsParent'] === esId) {
        // Set 'App' to 'N' for this child      
        subArray.at(index).get('App').setValue('N');
        // Recursively call the function to update all descendants
        this.setDescendantsToN(element['EsId'], subArray);
      }
    });
  }

  fetchStudentIAAtd(){
    this.spinner.show()
    const payload = {};
    this.Subjects = [];
    this.HeadSub = [];
    this.IAatd = false;
    this.IAMessage = ' ';
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'))
    payload['CoCode'] = this.CoCode;
    payload['EsCode'] = ''
    payload['EsParentId'] = ''
    payload['StuID'] = this.StudentPersonalId;
    payload['EmId'] = this.EmId
    this.umsService.getIAAtd(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        let attendanceData = res.data[0];
        res.data[0].forEach(element => {
          if(element.AttendStatus == 'N' || element.AttendStatus == null){
            this.Subjects.push(element.EsPSubCode +' - '+ element.EsName)
          }
        });
      
        if (res.data[0].find(item => item.AttendStatus === 'N' || item.AttendStatus === null)) {
          let data = {}
          data['message'] = "Attendance Is Less For " + this.Subjects.join(', ')  
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            
          });
          this.IAatd = true;
          this.IAMessage = "Attendance Is Less For " + this.Subjects.join(', ')
        }
        else{
          
          this.IAatd = false;
          this.IAMessage = ' ';
        
        }

      } else {
        this.spinner.hide()
        let data = {}
        this.IAatd = false;
        this.IAMessage = ' ';
        data['message'] = "Attendance Not Available For Heads"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.IAatd = false;
      this.IAMessage = ' ';
      // this.saveExamForm()
      // let data = {}
      // data['message'] = "Attendance Not Available"
      // data['title'] = 'Information'
      // data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    });
  }


saveExamForm() {
  this.saveSubjectSelections();
  const subArray = this.examForm.get('SubArray') as FormArray;
  const attendanceChangeSubjects = subArray.value.filter(
    x => x.EsType === 'S' && x.App === 'N'
  );
  if (!this.assignTableData || this.assignTableData.length === 0) {
    this.showError("Form data not loaded yet");
    return;
  }
  const oldSubject = this.assignTableData.filter(x => x.EsType === 'S');
  const newSubject = this.selectedCheckboxes.filter(x => x.EsType === 'S');

  if (!oldSubject.length || !newSubject.length) {
    this.showError("Subject not detected");
    return;
  }
  const subjectsToDelete = oldSubject.filter(
    old => !newSubject.some(n => n.EsId === old.SEsId)
  );

  const subjectsToAdd = newSubject.filter(
    n => !oldSubject.some(old => old.SEsId === n.EsId)
  );
  if (
    !subjectsToDelete.length &&
    !subjectsToAdd.length &&
    attendanceChangeSubjects.length === 0
  ) {
    this.validateGeneratedExams(this.payload);
    this.validationErrors = {};
    this.SaveDisable = true;
    this.showSuccess();
    return;
  }
  this.spinner.show();
  let totalCalls = subjectsToAdd.length + subjectsToDelete.length;
  let completedCalls = 0;
  const attendanceChange = () => {
    attendanceChangeSubjects.forEach(sub => {
      const payload = {
        EcId: this.EcIdNew,
        RgId: this.RgIdNew,
        SrNo: 1,
        EsId: sub.EsId,
        App: 'N',
        AMD: 'M'
      };
      this.umsService.SaveExmFrm(payload).subscribe();
    });
    this.validateGeneratedExams(this.payload);
    this.showSuccess();
    this.spinner.hide();
  };
  subjectsToDelete.forEach(sub => {
    const isAttendanceN = attendanceChangeSubjects
      .some(a => a.EsId === sub.SEsId);

    const payload = {
      EcId: this.EcIdNew,
      RgId: this.RgIdNew,
      SrNo: 1,
      EsId: sub.SEsId,
      App: isAttendanceN ? 'N' : 'Y',
      AMD: 'D'
    };
    this.umsService.SaveExmFrm(payload).subscribe(() => {
      completedCalls++;
      if (completedCalls === totalCalls) {
        attendanceChange();
      }
    });
  });
  subjectsToAdd.forEach(sub => {
    const isAttendanceN = attendanceChangeSubjects
      .some(a => a.EsId === sub.EsId);
    const payload = {
      EcId: this.EcIdNew,
      RgId: this.RgIdNew,
      SrNo: 1,
      EsId: sub.EsId,
      App: isAttendanceN ? 'N' : 'Y',
      AMD: 'A'
    };
    this.umsService.SaveExmFrm(payload).subscribe(() => {
      completedCalls++;
      if (completedCalls === totalCalls) {
        attendanceChange();
      }
    });
  });
  if (totalCalls === 0 && attendanceChangeSubjects.length > 0) {
    attendanceChange();
  }
}


showSuccess() {
  const data = {
    message: "Submitted Successfully",
    title: "Information",
    icon: "fas fa-check"
  };

  this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  this.dialogRef.afterClosed().subscribe(() => {
    this.SaveDisable = true;
    sessionStorage.setItem('allowSubjectChange', 'true');
    this.getAppliTracker();
    this.router.navigate(['Exam-Fees']);
  });
}

showError(msg) {
  const data = {
    message: msg,
    title: "Alert",
    icon: "fas fa-close"
  };
  this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
}

  checkvalidattion(subData,i){
    let abcd = this.examForm.get('SubArray') as FormArray;
      let payload = abcd.value;
    if(subData.value.showYN == ' ' || subData.value.showYN == null){
      if(subData.value.EsType == 'P'){
        if(payload[i-1].showYN == ' ' || payload[i-1].showYN == null){
          return true
        }
        else{
          return false
        }
      }
      else{
        return true
      }
    }
    else{
      return false;
    }
  }

  Print() {
    let data = {};
      data['message'] = 'Select from dropdown';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.dialog.open(PrintMsgBoxComponent, {
        disableClose: true,
        data,
      });
      this.dialogRef.afterClosed().subscribe(result => {
        if(result.length == 0){
          this.showPopup('No Data Found For This Session')
        }
        else if(result.length > 0){
          this.printAll(result[0]['SnNo'],result[0]['ShId'],result[0]['EfEmId'],result[0]['EfEmSrNo'],result[0]['EfId'],result[0]['RgId'],result[0]['SEcId'])
        }
      });
  }

  showPopup(message: string) {
    let data = {}
    data['message'] = message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.redirect('home');
    })
  }

  printAll(SnNo,ShId,EfEmId,EfEmSrNo,EfId,RgId,SEcId){
    this.resForReport;
    let payload1 = {}
    payload1['EcId'] = SEcId;
    payload1['EmId'] = EfEmId;
    payload1['EmSrNo'] = EfEmSrNo;
    payload1['RgId'] = RgId;
    payload1['ShId'] = ShId
    payload1['EfId'] = EfId;
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');

    var filter: any;
    filter = {
      // no secret data for instNo
      // "LoginId": parseInt(sessionStorage.getItem('StudentPersonalId')),
      "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
      "RptCode": 99,
      "InstName": '',
      "InstNo": this.InstId,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": parseInt(sessionStorage.getItem('StudentRGID')),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": SnNo,
      "Extra1": JSON.stringify(payload1),
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  searchValid() {
    this.spinner.show()
    let payload = {};
    payload['RgNo'] = sessionStorage.getItem('StudentRGID');
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['Valid'] = '';
    payload['Chng'] = '';
    payload['App'] = '';
    payload['EfId'] = 0
    this.umsService.fetchInputExams(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['Valid'] == 'X') {
          this.spinner.hide()
          this.SaveDisable = false
        }
        else if (res.data[0]['Valid'] == 'Y') {
          this.spinner.hide()
          this.SaveDisable = true
          
        }
        else{
          this.spinner.hide()
        }
      } else {
        this.spinner.hide()
        this.SaveDisable = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisable = false
    });
  }
 
  getAppliTracker(){
    this.spinner.show()
    let payload2 = {};
    payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload2['SessionId']= parseInt(sessionStorage.getItem('session')) ;
    this.umsService.fetchApplicationDetails(payload2).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        res.data.forEach(element => {
          if (element.ApplicationName == "Exam Form" && element.ApplicationSubDate != '') {
             this.SaveDisable = true

          }else{
            this.SaveDisable = false
          }
  
        });
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getCourse() {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        if (res.data[0]['CoRgPrfx'] != "" && res.data[0]['CoRgPrfx'] != 0) {
          this.prefix = res.data[0]['CoRgPrfx'];
          this.RegnNo = this.examForm.get('RegnNo').value; // Assuming your formGroup name is 'formGroup'
          this.formattedPrn = this.RegnNo.toString().padStart(8, '0');
        }
        else if (res.data[0]['CoRgPrfx'] == "" || res.data[0]['CoRgPrfx'] == 0 ){
        this.prefix = ''
        this.RegnNo = this.examForm.get('RegnNo').value;
        
        }
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  transPRN(RgNo){
    this.formattedPrn = RgNo.toString().padStart(8, '0');
  }

  getValidationErrorsKeys(): string[] {
    return Object.keys(this.validationErrors);
  }
  getSubjectOfferDetails(): string[] {
    const offerDetails: string[] = [];
  
    this.selectedCheckboxes.forEach(checkbox => {
      let offerDetail = `${checkbox.EsSupCode} - `;
  
      const mustOfferCodes = checkbox.EsCombCode ? checkbox.EsCombCode.split(',').map(code => code.trim()) : [];
      const mustOffer = mustOfferCodes.length > 0 ? `Must Offer: ${mustOfferCodes.join(', ')}` : null;
  
      const cantOfferCodes = checkbox.EsNoComb ? checkbox.EsNoComb.split(',').map(code => code.trim()) : [];
      const cantOffer = cantOfferCodes.length > 0 ? `Can't Offer: ${cantOfferCodes.join(', ')}` : null;
  
      if (mustOffer || cantOffer) {
        if (mustOffer && cantOffer) {
          offerDetail += `${mustOffer}, ${cantOffer}`;
        } else if (mustOffer) {
          offerDetail += mustOffer;
        } else if (cantOffer) {
          offerDetail += cantOffer;
        }
        
        offerDetails.push(offerDetail);
      }
    });
  
    return offerDetails;
  }
     getSubKeys(): string[] {
    return Object.keys(this.groupedSubjects);
  }
isCheckboxDisabled(checkbox: any): boolean {
  if (!checkbox) return false;
  
  const subjectCode = checkbox.EsCode || '';
  if (!subjectCode) return false;
  
  const relatedCheckboxSelected2 = this.selectedCheckboxes.some((selected) => {
    const combCodes = selected.EsCombCode ? selected.EsCombCode.split(',') : [];
    const noCombCodes = selected.EsNoComb ? selected.EsNoComb.split(',') : [];
    return combCodes.includes(subjectCode) || noCombCodes.includes(subjectCode);
  });

  return relatedCheckboxSelected2;
}
shouldCheckItemForSubject(item1): boolean {
  if (!item1) return false;
  const itemId = item1.EsId;
  const isChecked = this.selectedCheckboxes.some(item => item.EsId === itemId);
  return isChecked;
}
   shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);
  }

onCheckboxChanged(event: any, checkbox: any): void {
  if (checkbox.EsOpCode === ' ') {
    event.source.checked = true;
    return;
  }
  if (this.SaveDisable) return;
  checkbox.checked = event.checked;
  if (event.checked && checkbox.EsType === 'S') {
    this.applySubjectChange(checkbox);
  }
  this.handleRelatedCheckboxes(event, checkbox);
  this.rebuildSelectedCheckboxes();
  this.validateCheckboxesForItem();
  this.cdr.detectChanges();
}

getSubKeysForGroup(groupCode: string): string[] {
    return this.groupedSubjects2[groupCode] ? Object.keys(this.groupedSubjects2[groupCode]) : [];
}
   private handleRelatedCheckboxes(event: any, checkbox: any): void {
    const isChecked = event.checked;
    if (isChecked) {
      if (checkbox.EsCombCode) {
        const combCodes = checkbox.EsCombCode.split(','); 
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(combCodes.includes(childSubject.EsCode)){
                childSubject.checked = true;
                childSubject.disabled = false;
                // if (!this.selectedCheckboxes.includes(childSubject)) {
                //   this.selectedCheckboxes.push(childSubject);
                // }
                // if (!this.selectedCheckboxes.some((s: any) => s.EsCode === childSubject.EsCode)) {
                //   this.selectedCheckboxes.push(childSubject);
                // }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (combCodes.includes(subject.EsCode)) {
              subject.checked = true;
              subject.disabled = false;
              // if (!this.selectedCheckboxes.includes(subject)) {
              //   this.selectedCheckboxes.push(subject);
              // }
              // if (!this.selectedCheckboxes.some((s: any) => s.EsCode === subject.EsCode)) {
              //   this.selectedCheckboxes.push(subject);
              // }
            }
          }
        });
      }
  
      if (checkbox.EsNoComb) {
        const noCombCodes = checkbox.EsNoComb.split(','); 
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(noCombCodes.includes(childSubject.EsCode)){
                childSubject.checked = false;
                childSubject.disabled = true;
                const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === childSubject.EsCode);
                if(noCombIndex !== -1){
                  this.selectedCheckboxes.splice(noCombIndex, 1);
                }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (noCombCodes.includes(subject.EsCode)) {
              subject.checked = false;
              subject.disabled = true;
              const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === subject.EsCode);
              if (noCombIndex !== -1) {
                this.selectedCheckboxes.splice(noCombIndex, 1);
              }
              
            }
          }
          
        });
      }
    } else {
      if (checkbox.EsCombCode) {
        const combCodes = checkbox.EsCombCode.split(','); 
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(combCodes.includes(childSubject.EsCode)){
                childSubject.checked = false;
                childSubject.disabled = false;
                const combIndex = this.selectedCheckboxes.indexOf(childSubject);
                if(combIndex !== -1){
                  this.selectedCheckboxes.splice(combIndex, 1);
                }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (combCodes.includes(subject.EsCode)) {
              subject.checked = false;
              subject.disabled = false;
              const combIndex = this.selectedCheckboxes.indexOf(subject);
              if (combIndex !== -1) {
                this.selectedCheckboxes.splice(combIndex, 1);
              }
            }
          }
         
        });
  }
      if (checkbox.EsNoComb) {
        const noCombCodes = checkbox.EsNoComb.split(','); 
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(noCombCodes.includes(childSubject.EsCode)){
                childSubject.checked = false;
                childSubject.disabled = false;
                const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === childSubject.EsCode);
              if (noCombIndex !== -1) {
                this.selectedCheckboxes.splice(noCombIndex, 1);
              }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (noCombCodes.includes(subject.EsCode)) {
              subject.checked = false;
              subject.disabled = false;
              const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === subject.EsCode);
              if (noCombIndex !== -1) {
                this.selectedCheckboxes.splice(noCombIndex, 1);
              }
            }
          }
        });
      }
    }
  
    this.validateCheckboxesForItem();
    this.SubjectData = [...this.SubjectData];
  }

  validateCheckboxesForItem(): void {
    for (const item of this.optData) {
    const selectedForItem = this.selectedCheckboxes.filter(cb => {
    if (cb.EsOpCode === item.OpCode) return true;
    if (cb.EsOpCode === ' ') {
    return item.SubjectCodes?.includes(cb.EsCode);
  }
  return false;
});
      this.validateCheckboxes(item, selectedForItem);
    }
  }
validateCheckboxes(item: any, selectedCheckboxes1: any[]): void {
  const totalSelected = selectedCheckboxes1.length;
  const opMin = item.OpMin;
  const opMax = item.OpMax;
  const opCode = item.OpCode;

  if (totalSelected > opMax) {
    const last = selectedCheckboxes1[selectedCheckboxes1.length - 1];
    last.checked = false;

    this.validationErrors[opCode] =
      `For Option ${opCode} Select Only ${opMax}`;

    this.cdr.detectChanges();
    return;
  }

  if (totalSelected < opMin) {
    this.validationErrors[opCode] =
      `For Option ${opCode} Select Only ${opMin}`;
  } else {
    delete this.validationErrors[opCode];
  }
}


processAndDisplaySubjects() {
  
  this.Subs = false;
  this.OptSub = false;
  this.AllSub = [];
  this.Sub = [];
  this.groupedSubjects = {};
  //this.selectedCheckboxes = [];
  
  if (!this.SubjectData || this.SubjectData.length === 0) {
    return;
  }
  this.SubjectData.forEach(item => {
    const esType = item.EsType || 'S';
    if (esType === 'S') {
      this.Subs = true;
      const subjectObj = {
  EsId: item.EsId || 0,
  EsType: 'S',
  EsSupCode:  item.EsSupCode || '',
  EsCode: item.EsCode || '',
  EsName: item.EsName || '',
  EsOpCode: item.EsOpCode || ' ',
  EsParent: item.EsParent || 0,
checked: this.selectedCodeSet.has( item.EsCode),
disabled : false,
  original : item
};
    this.AllSub.push(subjectObj);
    this.Sub.push(subjectObj.EsOpCode);
    if (subjectObj.EsOpCode === ' ') {
      this.selectedCheckboxes.push(subjectObj);
      }
    } else if (esType === 'G') {
      this.OptSub = true;
    }
  });
  
  this.groupSubjects();
  this.cdr.detectChanges();
  
}

processSubjectData() {
  this.Subs = false;
  this.OptSub = false;
  this.selectedCheckboxes = [];
  this.GroupData = [];
  this.groupedSubjects = {};
  this.groupedSubjects2 = {};
  this.AllSub = [];
  this.Sub = [];

  if (!this.SubjectData || !Array.isArray(this.SubjectData)) {
    return;
  }
  this.SubjectData.forEach((element, index) => {    
    const subjectCode =  element.EsCode || '';
    const subjectName = element.EsName || '';
    const optionCode = element.EsOpCode || ' ';
    const subjectType = element.EsType || '';
    const subjectId = element.EsId || 0;
    const parentId = element.EsParent || 0;
        
    if (subjectType === 'S') {
      this.Subs = true;
      const subjectObj = {
        EsId: subjectId,
        EsType: subjectType,
        EsSupCode: subjectCode, 
        EsName: subjectName,
        EsOpCode: optionCode,
        EsParent: parentId,
        checked: false, 
        originalData: element
      };
      if (!this.AllSub.some(item => item.EsId === subjectId)) {
        this.AllSub.push(subjectObj);
        this.Sub.push(optionCode);
      }
      let wasSelected = false;
      if (this.newSelectedValues && this.newSelectedValues.length > 0) {
        wasSelected = this.newSelectedValues.some(item => {
          const match = item.Code === subjectCode;
          if (match) {
          }
          return match;
        });
      }
      if (wasSelected || optionCode === ' ') {
  subjectObj.checked = true;   
  this.selectedCheckboxes.push(subjectObj);
}
    } else if (subjectType === 'G') {
      this.OptSub = true;
      const groupObj = {
        EsId: subjectId,
        EsType: subjectType,
        EsSupCode: subjectCode,
        EsName: subjectName,
        EsOpCode: optionCode,
        EsParent: parentId,
        children: element.children || [],
        originalData: element
      };
      let wasSelected = false;
      if (this.newSelectedValues && this.newSelectedValues.length > 0) {
        wasSelected = this.newSelectedValues.some(item => {
          return item.Code === subjectCode;
        });
      }
      if (wasSelected || optionCode === ' ') {
        const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === subjectId);
        if (!isDuplicate) {
          this.selectedCheckboxes.push(groupObj);
        }
      }
      if (!this.GroupData.some(item => item.EsId === subjectId)) {
        this.GroupData.push(groupObj);
      }
      if (element.children && Array.isArray(element.children) && element.children.length > 0) {
        
        element.children.forEach((childElement, childIndex) => {
          const childCode =  childElement.EsCode || '';
          const childName = childElement.EsName || '';
          const childOptionCode = childElement.EsOpCode || ' ';
          const childId = childElement.EsId || 0;
          const childParentId = childElement.EsParent || subjectId;
          const childObj = {
            EsId: childId,
            EsType: 'S', 
            EsSupCode: childCode,
            EsName: childName,
            EsOpCode: childOptionCode,
            EsParent: childParentId,
            originalData: childElement
          };
          let wasChildSelected = false;
          if (this.newSelectedValues && this.newSelectedValues.length > 0) {
            wasChildSelected = this.newSelectedValues.some(item => {
              return item.Code === childCode;
            });
          }
          if (wasChildSelected || childOptionCode === ' ') {
            const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === childId);
            if (!isDuplicate) {
              this.selectedCheckboxes.push(childObj);
            }
          }
        });
      } else {
      }
    } else {
    }
  });
  this.groupSubjects();
  this.groupSubjects2();
  if (this.AllSub.length > 0 || this.GroupData.length > 0) {
    this.subjectsData = true;
  }
}
isSubjectPreviouslySelected(subjectCode: string): boolean {
  return false; 
}

isGroupPreviouslySelected(groupId: number): boolean {
  return false; 
}

getSubjectOptions() {
  const payload = {
    OpEmId: this.EmId,
    OpStrId: this.addmissionData?.SubBrId || 0
  };
  this.umsService.getOption(payload).subscribe(res => {
    if (res.status && res.data) {
      this.optData = res.data.map(o => ({
        ...o,
        SubjectCodes: o.Subjects
          ? o.Subjects.split(',').map(x => x.trim())
          : []
      }));
      this.cdr.detectChanges();
    }
  });
}

groupSubjects() {
  this.groupedSubjects = {};
  if (!this.AllSub || this.AllSub.length === 0) return;
  this.AllSub.forEach(subject => {
    const optionCode = subject.EsOpCode || ' ';
    const code =  subject.EsCode || '';

    if (!this.groupedSubjects[optionCode]) {
      this.groupedSubjects[optionCode] = [];
    }
    const isMandatory = optionCode === ' ';
    subject.checked = this.selectedCodeSet.has(code) || isMandatory; 
    subject.disabled = isMandatory;
    this.groupedSubjects[optionCode].push(subject);
  });
  if (this.Failed) {
  const allowedCodes = new Set(
    (this.addmissionData?.StuSubjectRg || '')
      .split(',')
      .map(c => c.trim())
  );

  this.groupedSubjects = Object.keys(this.groupedSubjects)
    .reduce((acc: any, key: string) => {

      const filtered = this.groupedSubjects[key].filter((sub: any) =>
        allowedCodes.has(sub.EsCode) && sub.checked === true
      );

      if (filtered.length > 0) {
        acc[key] = filtered;
      }

      return acc;
    }, {});
}


}

groupSubjects2() {
  this.groupedSubjects2 = {};
  this.GroupData.forEach((group) => {
    const groupCode = group.EsCode;
    if (!this.groupedSubjects2[groupCode]) {
      this.groupedSubjects2[groupCode] = {};
    }
    group.children.forEach((subjectItem) => {
      const subValue = subjectItem.EsOpCode || 'Mandatory';
      if (!this.groupedSubjects2[groupCode][subValue]) {
        this.groupedSubjects2[groupCode][subValue] = [];
      }
      this.groupedSubjects2[groupCode][subValue].push(subjectItem);
    });
  });
}

loadAdmissionSubjects() {
  const admissionData = sessionStorage.getItem('AdmissionData');
  if (admissionData) {
    return JSON.parse(admissionData);
  }
  return null;
}
getSubjectCode(item: any): string {
  return  item.EsSupCode || '';
}

getSubjectName(item: any): string {
  return item.EsName || '';
}
getSubjectOption(item: any): string {
  return item.EsOpCode || ' ';
}
loadPreviouslySelectedSubjects() {
  const payload = {
    StuId: this.StudentPersonalId,
    SubSession: this.SessionNo
  };

  this.umsService.getSubSelectionDetails(payload).subscribe(res => {
    if(res.status && res.data?.length){
      const saved = res.data[0].StuSubjectRgCopy;
      if(!saved){
        this.processAfterSelection();
        return;
      }
      const codes = saved.split(',').map(x => x.split('-')[0].trim());
      this.applyPreviouslySelectedSubjects(codes);
    }
    else{
      this.processAfterSelection();
    }
  });
}

applyPreviouslySelectedSubjects(codes: string[]) {
  this.selectedCodeSet = new Set(
    codes.map(c => (c || '').trim())
  );
  this.processAfterSelection();
}

processAfterSelection(){
  const keepChangeFlag = this.allowSubjectChange;
  this.AllSub = this.SubjectData;   

  this.groupSubjects();
  this.groupSubjects2();

  this.subjectsData = true;
  this.allowSubjectChange = keepChangeFlag;  
  this.cdr.detectChanges();
}
applySubjectChange(checkbox: any) {
  const arr = this.examForm.get('SubArray') as FormArray;
  const row = arr.value.find(x => x.EsType === 'S');
  const index = arr.value.findIndex(x => x.EsType === 'S');
  if (index === -1) return;
  arr.at(index).get('EsId').setValue(checkbox.EsId);   
}
private rebuildSelectedCheckboxes(): void {
  const all: any[] = [];
  Object.values(this.groupedSubjects || {}).forEach((list: any[]) => {
    list.forEach(sub => {
      if (sub.checked === true) {
        all.push(sub);
      }
    });
  });
  Object.values(this.groupedSubjects2 || {}).forEach((group: any) => {
    Object.values(group).forEach((children: any[]) => {
      children.forEach(sub => {
        if (sub.checked === true) {
          all.push(sub);
        }
      });
    });
  });
  this.selectedCheckboxes = all;
}
}
